import {Injectable} from '@angular/core';
import {handleResult} from "@share/utils/handle-result";
import {Result} from "@domain/common/http/result";
import {FormulaireHttpService} from "@services/admin/parametre/formulaire/formulaire-http.service";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {finalize} from "rxjs/operators";
import {ParamDossierVoyage} from "@domain/admin/parametre/formulaire/param-dossier-voyage";

/**
 * Service du formulaire Voyage
 *
 * @author Lionel Gimenez
 * @date 11/09/2025
 */
@Injectable()
export class FormulaireVoyageService {
    /** Indicateur pour savoir si on est en cours de sauvegarde */
    isSaving: boolean = false;

    /** Paramètres Formulaire Voyage */
    paramDossierVoyage: ParamDossierVoyage;

    /**
     * Constructeur
     */
    constructor(
        private formulaireHttpService: FormulaireHttpService,
        private translateService: TranslateService,
        private toastrService: ToastrService
    ) {
    }

    /**
     * Charge les données
     */
    load(): void {
        this.formulaireHttpService.loadFormulaireVoyage()
            .pipe(handleResult(this.translateService, this.toastrService, null, 'global.errors.generic'))
            .subscribe((result: Result) => {
                this.paramDossierVoyage = result.data.param;
            });
    }

    /**
     * Sauvegarde les données
     */
    save(): void {
        this.isSaving = true;

        this.formulaireHttpService.saveFormulaireVoyage(this.paramDossierVoyage)
            .pipe(
                handleResult(this.translateService, this.toastrService),
                finalize(() => this.isSaving = false))
            .subscribe((result: Result) => {
                //Refresh
                this.load();
            });
    }
}
